<script>
  // The feed as the server sent it: already filtered by the `feed` tab, newest
  // first, each row carrying its own verdict and whether it is new since the
  // previous refresh. Switching the tab is a partial visit that refetches it.
  import { page, router } from '@inertiajs/svelte'
  import FilterTabs from '../../components/filter_tabs.svelte'
  import { NEW_ROW_FLASH_MS, SCROLLED_DOWN_PX, subjectKey } from '../../lib/moderation_live.js'
  import ActivityRow from './activity_row.svelte'

  let { activity, filter = 'all', filters = [], live, feed, onOpen } = $props()

  let scroller = $state(null)
  let scrolledDown = $state(false)

  const selectFilter = (key) => {
    const url = new URL($page.url, window.location.origin)
    if (key === 'all') url.searchParams.delete('feed')
    else url.searchParams.set('feed', key)
    router.get(`${url.pathname}${url.search}`, {}, { only: ['activity', 'feed'], preserveState: true, preserveScroll: true })
  }

  const events = $derived(activity.events)
  const newVisibleCount = $derived(events.filter((event) => live.newIds.has(event.id)).length)

  // New rows flash in place while the list is at the top; once the flash has
  // played there is nothing left to acknowledge. Scrolled down, the pill holds
  // the count until the moderator jumps back up.
  $effect(() => {
    if (live.newIds.size === 0 || scrolledDown) return
    const timer = setTimeout(live.markSeen, NEW_ROW_FLASH_MS)
    return () => clearTimeout(timer)
  })

  const jumpToNew = () => {
    scroller?.scrollTo({ top: 0, behavior: 'smooth' })
    scrolledDown = false
    live.markSeen()
  }
</script>

<div class="card bg-base-100 border border-base-300 shadow-sm">
  <div class="px-4 pt-4 flex items-end justify-between gap-3 flex-wrap">
    <h2 class="card-title">
      Activity <span class="text-sm font-normal text-base-content/60">{events.length} shown</span>
    </h2>
    <FilterTabs tabs={filters} param="feed" active={filter} onselect={selectFilter} />
  </div>

  {#if activity.burst}
    <div class="alert alert-warning alert-soft rounded-none text-sm" role="status">
      A lot came in at once — showing the newest {activity.feed_limit}. Older activity is in the queue pages.
    </div>
  {/if}

  <div
    class="relative overflow-y-auto max-h-[calc(100vh-14rem)] border-t border-base-300"
    bind:this={scroller}
    onscroll={() => (scrolledDown = scroller.scrollTop > SCROLLED_DOWN_PX)}
  >
    {#if scrolledDown && newVisibleCount > 0}
      <div class="sticky top-2 z-10 h-0 flex justify-center">
        <button type="button" class="badge badge-primary badge-lg shadow cursor-pointer" onclick={jumpToNew}>
          {newVisibleCount} new ↑
        </button>
      </div>
    {/if}

    {#if events.length === 0}
      <p class="p-8 text-center text-sm text-base-content/60">
        Nothing here yet. New submissions, reports and failed uploads appear as they happen.
      </p>
    {:else}
      <ul>
        {#each events as event (event.id)}
          {@const key = subjectKey(event)}
          <ActivityRow
            {event}
            actions={feed}
            {onOpen}
            isNew={live.newIds.has(event.id)}
            busy={!!(key && feed.busyKeys[key])}
            canUndo={event.reviewed_by_you && feed.undoStack.includes(event.quest_submission?.id)}
          />
        {/each}
      </ul>
    {/if}
  </div>
</div>
